import { contact } from "../../content/site";
import { Button } from "../Button/Button";
import * as styles from "./ContactForm.css";

export function ContactForm() {
  const subject = encodeURIComponent("Project enquiry for Ayro Technologies");
  const body = encodeURIComponent(
    "Hello Ayro Technologies,\n\nI would like to discuss a project.\n\nProject context:\n\nTimeline:\n\nBudget range:\n\n"
  );

  return (
    <form className={styles.form}>
      <div className={styles.row}>
        <label className={styles.field}>
          <span className={styles.label}>Name</span>
          <input className={styles.input} type="text" name="name" autoComplete="name" />
        </label>
        <label className={styles.field}>
          <span className={styles.label}>Email</span>
          <input
            className={styles.input}
            type="email"
            name="email"
            autoComplete="email"
          />
        </label>
      </div>
      <label className={styles.field}>
        <span className={styles.label}>Project area</span>
        <select className={styles.input} name="service" defaultValue="">
          <option value="" disabled>
            Select an area
          </option>
          <option>Consulting</option>
          <option>Audits & Assessments</option>
          <option>Bespoke Software Solutions</option>
          <option>Project Management</option>
        </select>
      </label>
      <label className={styles.field}>
        <span className={styles.label}>What would you like to discuss?</span>
        <textarea className={styles.textarea} name="message" />
      </label>
      <Button href={`mailto:${contact.email}?subject=${subject}&body=${body}`}>
        Email Ayro Technologies
      </Button>
    </form>
  );
}
